// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__36bCf","header":"PatientQuestionnaire_header__3Ei-J","info":"PatientQuestionnaire_info__QQayn"};